module.exports = __webpack_public_path__ + "static/media/like.d176a2e9.svg";